<div class="d-flex justify-content-center">
    <!-- <span
        stop-click-bubble
        role="button"
        class="font-5">
        <svg-icon key="share" fontSize="1.5rem"></svg-icon>
    </span> -->

    <span
        (click)="navigateToDetailPage()"
        stop-click-bubble
        role="button"
        class="font-5">
        <svg-icon key="folder-search" fontSize="1.5rem"></svg-icon>
    </span>

    <!-- <span
        stop-click-bubble
        role="button"
        class="font-5">
        <svg-icon key="remove" fontSize="1.5rem"></svg-icon>
    </span> -->
</div>
